import { axios } from '@/utils/request'

const api = {
  sellerList: '/adminapi/seller/sellerlist',
  customerList: '/adminapi/seller/customerList',
  userDetail: '/adminapi/user/userdetail',
  changeSeller: '/adminapi/seller/changeSeller',
  sellerGroupList: '/adminapi/seller/groupList',
}

export default api

export function getSellerList(parameter) {
  return axios({
    url: api.sellerList,
    method: 'get',
    params: parameter
  })
}
export function getUserDetail(parameter) {
  return axios({
    url: api.userDetail,
    method: 'get',
    params: parameter
  })
}

export function changeSeller(parameter) {
  return axios({
    url: api.changeSeller,
    method: 'post',
    data: parameter
  })
}

export function getSellerGroupList(parameter) {
  return axios({
    url: api.sellerGroupList,
    method: 'get',
    params: parameter
  })
}
export function getSellerCustomerList(parameter) {
  return axios({
    url: api.customerList,
    method: 'get',
    params: parameter
  })
}
export function setPassword(parameter) {
  return axios({
    url: api.setPassword,
    method: 'get',
    params: parameter
  })
}


export function getUserOptions(parameter) {
  return axios({
    url: api.userOptions,
    method: 'get',
    params: parameter
  })
}

